import logo from "../../assets/logo.png";
import { Fragment, useContext, useEffect, useRef, useState } from "react";
import { AuthContext } from "../../context";
import styles from "./styles.module.css";
import { adminLinks, userLinks } from "./links";
import {
  FaSignOutAlt,
  FaUser,
  FaBars,
  FaTimes,
  FaCaretDown,
} from "react-icons/fa";
import { RiCustomerService2Fill } from "react-icons/ri";
import { Link, useNavigate } from "react-router-dom";
import { IconType } from "react-icons";

type NavItem = {
  route: string;
  name: string;
  Icon: IconType;
  allowed: string[];
  children?: any[];
};

type NavProps = {
  pageTitle: string;
};

const Navigation = ({ pageTitle }: NavProps) => {
  const [newItems, setNewItems] = useState({} as any);
  const { user, logout, isTourComplete } = useContext(AuthContext);
  const [expanded, setExpanded] = useState(false);
  const navigate = useNavigate();
  const role: any = user?.role;
  const navLinks: NavItem[] = role === "Admin" ? adminLinks : userLinks;

  const hasPermission = (roles: string, allowedRoles: string[]) => {
    return allowedRoles.includes(roles);
  };

  const logoutHandler = () => {
    logout();
    navigate("/");
  };

  const toggleHandler = (id: any) => {
    setNewItems((prevState: any) => ({ ...prevState, [id]: !prevState[id] }));
  };

  const tourSelector = (index: number): string => {
    console.log(index);
    return role === "Admin"
      ? `admin-step-${index + 1}`
      : `user-step-${index + 1}`;
  };

  const renderLinks = (links: any) => {
    return links.map((item: any, i: number) => {
      if (!hasPermission(role, item?.allowed)) return null;

      if (item.children) {
        return (
          <div key={i}>
            <li
              className={`${styles.navItem} ${
                pageTitle === item?.name ? styles.active : ""
              } ${item.className}`}
              onClick={() => toggleHandler(i)}
            >
              <Link to={item.route}>
                <item.Icon className={styles.icon} />
                <span className={styles.text}>{item.name}</span>&nbsp;&nbsp;
                <FaCaretDown />
              </Link>
            </li>

            {newItems[i] && (
              <div className={styles.childContainer}>
                <ul className={styles.navList}>
                  {item.children.map((child: any, x: number) => (
                    <li
                      key={x}
                      className={`${styles.navItem} ${
                        pageTitle === item?.name ? styles.active : ""
                      }`}
                    >
                      <Link to={child.route}>
                        <child.Icon className={styles.icon} />

                        <span className={styles.text}>{child.name}</span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        );
      }

      return (
        <li
          key={i}
          className={`${styles.navItem} ${
            pageTitle === item?.name ? styles.active : ""
          } ${item.className}`}
        >
          <Link to={item.route}>
            <item.Icon className={styles.icon} />
            <span className={styles.text}>{item.name}</span>
          </Link>
        </li>
      );
    });
  };
  return (
    <>
      {/* Mobile Menu Toggle */}
      <div
        className={styles.mobileToggle}
        onClick={() => setExpanded(!expanded)}
      >
        {expanded ? <FaTimes /> : <FaBars />}
      </div>

      {/* Sidebar */}
      <div
        className={`${styles.sidebar}`}
        // onMouseEnter={() => window.innerWidth > 768 && setExpanded(true)}
        // onMouseLeave={() => window.innerWidth > 768 && setExpanded(false)}
      >
        <div className={styles.logoContainer}>
          <img src={logo} alt="Logo" className={styles.logo} />
        </div>

        <ul className={styles.navList}>
          {/* {navLinks.map(
            (item, i) =>
              hasPermission(role, item?.allowed) && (
                <Fragment key={i}>
                  <li
                    className={`${styles.navItem} ${
                      pageTitle === item?.name ? styles.active : ""
                    }`}
                  >
                    <Link to={item.route}>
                      <item.Icon className={styles.icon} />
                      <span className={styles.text}>{item.name}</span>
                    </Link>
                  </li>
                </Fragment>
              )
          )} */}
          {renderLinks(navLinks)}

          {user?.role !== "Admin" && (
            <>
              <li className={styles.navItem}>
                <Link to="/app/profile">
                  <FaUser className={styles.icon} />
                  <span className={styles.text}>Account</span>
                </Link>
              </li>
              <li className={styles.navItem}>
                <Link to="/app/contact">
                  <RiCustomerService2Fill className={styles.icon} />
                  <span className={styles.text}>Contact Us</span>
                </Link>
              </li>
            </>
          )}

          <li className={styles.navItem}>
            <Link to="#" onClick={logoutHandler}>
              <FaSignOutAlt className={styles.icon} />
              <span className={styles.text}>Logout</span>
            </Link>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Navigation;
